"use strict";

exports.__esModule = true;
exports.CompatRoute = CompatRoute;
exports.Prompt = Prompt;
exports.RootRoutes = RootRoutes;
exports.withRouter = withRouter;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /**
 * React Router v5 → v6 compatibility helpers for HashRouter apps.
 * Provides withRouter (history/match/location shim), Prompt, CompatRoute, and RootRoutes.
 */
/**
 * RR6 descendant <Routes> match against the remaining path under the parent route.
 * This app's nested Switches historically matched the full URL (RR5). RootRoutes
 * clears parent route context so absolute getScreenPath(...) routes keep working.
 *
 * The value mirrors react-router 6.30.6's RouteContext default exactly
 * ({ outlet, matches, isDataRoute }). UNSAFE_RouteContext is internal API: on any
 * react-router bump, re-check the default in react-router's dist against this
 * object before trusting the upgrade.
 */
var ROOT_ROUTE_CONTEXT = {
  outlet: null,
  matches: [],
  isDataRoute: false
};
function RootRoutes(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.UNSAFE_RouteContext.Provider, {
    value: ROOT_ROUTE_CONTEXT
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, props));
}
function createHistoryShim(navigate, location) {
  return {
    length: typeof window !== "undefined" ? window.history.length : 0,
    action: "PUSH",
    location: location,
    push: function push(to, state) {
      if (typeof to === "number") {
        navigate(to);
        return;
      }
      navigate(to, {
        state: state,
        replace: false
      });
    },
    replace: function replace(to, state) {
      navigate(to, {
        state: state,
        replace: true
      });
    },
    go: function go(n) {
      navigate(n);
    },
    goBack: function goBack() {
      navigate(-1);
    },
    goForward: function goForward() {
      navigate(1);
    },
    canGo: function canGo() {
      return true;
    },
    block: function block() {
      return function () {};
    },
    listen: function listen() {
      return function () {};
    },
    createHref: function createHref(to) {
      if (typeof to === "string") return to;
      var _ref = to || {},
        _ref$pathname = _ref.pathname,
        pathname = _ref$pathname === void 0 ? "" : _ref$pathname,
        _ref$search = _ref.search,
        search = _ref$search === void 0 ? "" : _ref$search,
        _ref$hash = _ref.hash,
        hash = _ref$hash === void 0 ? "" : _ref$hash;
      return "" + pathname + search + hash;
    }
  };
}
function createMatchShim(params, pathname) {
  return {
    params: params || {},
    path: pathname,
    url: pathname,
    isExact: true
  };
}

/**
 * Drop-in replacement for react-router-dom v5 withRouter.
 */
function withRouter(Component) {
  var WithRouter = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    var location = (0, _reactRouterDom.useLocation)();
    var navigate = (0, _reactRouterDom.useNavigate)();
    var params = (0, _reactRouterDom.useParams)();
    var history = (0, _react.useMemo)(function () {
      return createHistoryShim(navigate, location);
    }, [navigate, location]);
    var match = (0, _react.useMemo)(function () {
      return createMatchShim(params, location.pathname);
    }, [params, location.pathname]);
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
      ref: ref,
      history: history,
      location: location,
      match: match,
      navigate: navigate
    }));
  });
  WithRouter.displayName = "withRouter(" + (Component.displayName || Component.name || "Component") + ")";
  WithRouter.WrappedComponent = Component;
  return WithRouter;
}

/**
 * Drop-in replacement for react-router-dom v5 <Prompt>.
 *
 * Blocking a navigation needs React Router's blocker API, which exists only under
 * a data router (App renders through createHashRouter). Outside one — every test
 * renders a plain MemoryRouter — there is nothing to hook into, so the Prompt
 * renders nothing instead of letting useBlocker throw.
 *
 * The decision is made synchronously inside the blocker function, the way v5's
 * history.block did, rather than through react-router's unstable_usePrompt. That
 * hook confirms in an effect and proceeds on a setTimeout; a parent that navigates
 * away and unmounts the editor in the same tick (DeviceListScreenPlantTwin after a
 * save) removes the blocker before the timeout fires and the navigation is
 * silently dropped. Like v5, beforeunload is left alone: reload and tab-close are
 * deliberately not guarded.
 */
function Prompt(_ref2) {
  var _ref2$when = _ref2.when,
    when = _ref2$when === void 0 ? true : _ref2$when,
    _ref2$message = _ref2.message,
    message = _ref2$message === void 0 ? "Are you sure you want to leave?" : _ref2$message;
  var inDataRouter = _react["default"].useContext(_reactRouterDom.UNSAFE_DataRouterContext) != null;
  var text = typeof message === "function" ? message() : message;
  if (!inDataRouter) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(DataRouterPrompt, {
    when: Boolean(when),
    message: text
  });
}
function DataRouterPrompt(_ref3) {
  var when = _ref3.when,
    message = _ref3.message;
  var blocker = (0, _reactRouterDom.useBlocker)(function () {
    return when && !window.confirm(message);
  });
  _react["default"].useEffect(function () {
    // The user declined: clear the blocked state so the next attempt asks again.
    if (blocker.state === "blocked") {
      blocker.reset();
    }
  }, [blocker]);
  return null;
}

/**
 * Injects v5-style route props (history/match/location/navigate) into element/component/render.
 */
function RouteElement(_ref4) {
  var element = _ref4.element,
    Component = _ref4.component,
    render = _ref4.render,
    children = _ref4.children;
  var location = (0, _reactRouterDom.useLocation)();
  var navigate = (0, _reactRouterDom.useNavigate)();
  var params = (0, _reactRouterDom.useParams)();
  var history = (0, _react.useMemo)(function () {
    return createHistoryShim(navigate, location);
  }, [navigate, location]);
  var match = (0, _react.useMemo)(function () {
    return createMatchShim(params, location.pathname);
  }, [params, location.pathname]);
  var routeProps = {
    history: history,
    location: location,
    match: match,
    navigate: navigate
  };
  if (element != null) {
    // Same route-prop injection as CheckAccessRoute; host elements left untouched.
    return /*#__PURE__*/_react["default"].isValidElement(element) && typeof element.type !== "string" ? /*#__PURE__*/_react["default"].cloneElement(element, routeProps) : element;
  }
  if (Component) {
    return /*#__PURE__*/_react["default"].createElement(Component, routeProps);
  }
  if (render) {
    return render(routeProps);
  }
  if (children) {
    return typeof children === "function" ? children(routeProps) : children;
  }
  return null;
}

/**
 * Drop-in Route content supporting v5 component/render props.
 * Use as: <Route path={...} element={<CompatRoute component={X} />} />
 * (Must not wrap <Route> — RR6 only allows Route/Fragment as Routes children.)
 */
function CompatRoute(_ref5) {
  var element = _ref5.element,
    component = _ref5.component,
    render = _ref5.render,
    children = _ref5.children;
  return /*#__PURE__*/_react["default"].createElement(RouteElement, {
    element: element,
    component: component,
    render: render,
    children: children
  });
}